import Message from "../../message";

export default class SeasonRewards extends Message
{
    handle()
    {
        console.log('SEASON REWARDS', this.message.rewards);
    }
}